import React from 'react';
import useTTUStore from '@stores/ttu';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { getTTUIsGoalEnabled } from '@stores/selectors/ttuSelectors';
import useWindowSize from '@hooks/useWindowSize';
import PlatformTTU from '@cont/TalkToUnacademy/PlatformTTU';
import { useRouter } from 'next/router';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsSubscribed } from '@api/selectors/subscription';
import TTUBanner from './GenericBanner';
import TopHeader from './TopHeader';
import SubscriptionOffers from './SubscriptionOffers';
import SubscriptionBenefitsMWeb from './NewSubscriptionBenefits/SubscriptionBenefitsMWeb';
import SubscriptionBenefitsWeb from './NewSubscriptionBenefits/SubscriptionBenefitsWeb';

const NewSubscription = ({ subscriptionData, goalDetails, isPlatformGoal }) => {
  const router = useRouter();
  const { goalUID } = router.query;
  const { goalInfo } = useGoalInfo(goalUID);

  const GetBanner = () => {
    const isGoalEnabled = useTTUStore(getTTUIsGoalEnabled);
    const isPlusSubscribed = useMyInfo(getIsSubscribed);
    const { isMobile } = useWindowSize();
    if (isPlatformGoal) return <PlatformTTU goalDetails={goalDetails} />;
    if (isGoalEnabled && !isPlusSubscribed && !isMobile)
      return <TTUBanner goalDetails={goalDetails} />;
    return null;
  };

  return (
    <>
      <TopHeader
        data={goalInfo}
        subscriptionOffers={subscriptionData.lowestPriceMap}
      />
      <SubscriptionOffers data={subscriptionData.availableOffers} />
      <SubscriptionBenefitsMWeb
        data={subscriptionData.lowestPriceMap}
        goalName={goalInfo?.name || ''}
        goal={goalInfo}
      />
      <SubscriptionBenefitsWeb
        data={subscriptionData.lowestPriceMap}
        goalName={goalInfo?.name || ''}
        goal={goalInfo}
      />
      {GetBanner()}
    </>
  );
};

export default NewSubscription;
